import type { Locale } from "./prefs";

/** "/" commands in the composer: pick one and its prompt template replaces the text (cursor lands at the end, ready to add the subject). */
export interface SlashCommand {
  cmd: string;
  en: string;
  ar: string;
}

export const SLASH: SlashCommand[] = [
  { cmd: "summarize", en: "Summarize this in 5 bullet points:\n\n", ar: "لخّص ده في 5 نقاط:\n\n" },
  {
    cmd: "translate",
    en: "Translate to Arabic (keep the tone and formatting):\n\n",
    ar: "ترجم للإنجليزي بنفس النبرة والتنسيق:\n\n",
  },
  {
    cmd: "explain",
    en: "Explain this simply, with one example:\n\n",
    ar: "اشرح ده ببساطة مع مثال واحد:\n\n",
  },
  { cmd: "eli5", en: "Explain like I'm five:\n\n", ar: "اشرحلي كأني طفل عمره 5 سنين:\n\n" },
  {
    cmd: "fix",
    en: "Find the bug in this code, explain the cause in one line, and give the fixed code:\n\n```\n\n```",
    ar: "دوّر على الغلط في الكود ده، اشرح السبب في سطر، وادّيني الكود بعد التصليح:\n\n```\n\n```",
  },
  {
    cmd: "shorten",
    en: "Make this shorter without losing the meaning:\n\n",
    ar: "اختصر ده من غير ما المعنى يضيع:\n\n",
  },
  {
    cmd: "expand",
    en: "Expand this with more detail and examples:\n\n",
    ar: "وسّع ده بتفاصيل وأمثلة أكتر:\n\n",
  },
  {
    cmd: "proofread",
    en: "Proofread and correct this text; list what you changed:\n\n",
    ar: "راجع النص ده لغويًا وصحّحه، واكتبلي إيه اللي اتغيّر:\n\n",
  },
  { cmd: "email", en: "Write a professional email about:\n\n", ar: "اكتبلي إيميل احترافي عن:\n\n" },
  { cmd: "table", en: "Turn this into a clear table:\n\n", ar: "حوّل ده لجدول واضح:\n\n" },
  {
    cmd: "plan",
    en: "Make a step-by-step plan with owners, dates and risks for:\n\n",
    ar: "اعمل خطة خطوة بخطوة بمسؤولين ومواعيد ومخاطر لـ:\n\n",
  },
  {
    cmd: "formula",
    en: "Write the best Excel formula (and explain it) for:\n\n",
    ar: "اكتبلي أحسن معادلة إكسل (واشرحها) لـ:\n\n",
  },
  {
    cmd: "sql",
    en: "Write an optimized SQL query for:\n\n",
    ar: "اكتبلي استعلام SQL محسّن لـ:\n\n",
  },
  {
    cmd: "prompt",
    en: "Rewrite this as a much better prompt for an AI model:\n\n",
    ar: "أعد كتابة ده كبرومبت أحسن بكتير لموديل ذكاء اصطناعي:\n\n",
  },
];

/** Commands matching what was typed after "/" (only while it is a single word at the start of the message). */
export function matchSlash(text: string): SlashCommand[] {
  const m = /^\/([a-z]*)$/i.exec(text);
  if (!m) return [];
  const q = (m[1] ?? "").toLowerCase();
  return SLASH.filter((c) => c.cmd.startsWith(q));
}

export const slashTemplate = (c: SlashCommand, locale: Locale) => (locale === "ar" ? c.ar : c.en);
